const getIconByReportClassId = (reportClassId, builtInTemplates) => {
    const template = builtInTemplates.find(
        (item) => item.reportClassId === reportClassId,
    );
    return template.icon;
};

export default getIconByReportClassId;
